<template>
  <button class="button" type="button">
    <slot></slot>
  </button>
</template>

<script lang="ts" setup></script>

<style lang="scss">
.button {
  display: inline-block;
  min-height: 38px;
  margin-right: 1rem;
  padding: rem-calc(4px) rem-calc(16px);
  color: var(--theme-button-content-color);
  border-radius: 50px;
  border: 2px solid var(--theme-button-border-color);
  background-color: transparent;
  cursor: pointer;

  &:disabled {
    cursor: default;
  }

  &--default {
    @include button-filled;
  }

  &--default-denary {
    @include button-filled($bg-color: var(--theme-colors-denary), $bg-color-hover-clicked: var(--theme-colors-nonary));
  }

  &--button-text-icon {
    @include button-text-icon;

    svg {
      display: inline;
      margin-left: rem-calc(20px);
      width: 24px;
      vertical-align: middle;
      stroke: var(--default-button-text-color);
      fill: transparent;
    }
  }

  &--button-icon {
    @include button-icon;

    svg {
      display: block;
      width: 24px;
      height: auto;
      stroke: var(--default-button-text-color);
      fill: transparent;
    }
  }

  &--button-outlined {
    @include button-outlined;
  }

  &:last-child {
    margin-right: 0;
  }

  &--full {
    color: var(--default-button-text-color);
    background-color: var(--theme-button-background-color);
  }

  &--round {
    border-radius: 50%;
    aspect-ratio: 1/1;
  }

  &--icon {
    width: 38px;
    height: 38px;
    padding: rem-calc(10px);
    aspect-ratio: 1/1;

    svg {
      width: 100%;
    }
  }

  &--icon-cart {
    margin: 0;
  }

  &--filled {
    background-color: var(--theme-button-background-color);
  }

  &--no-border {
    border: 0;
  }
}
.close-button {
  &__icon {
    width: 16px;
  }
}
</style>
